import { client } from "../client";

export const login = (params) => {
  const user = {
    flag: "token",
    parameters: { ...params },
  };
  return client.post("/auth", user);
};

export const signup = (params) => {
  const user = {
    flag: "signup",
    parameters: { ...params },
  };
  return client.post("/auth", user);
};

export const refresh_token = (params) => {
  const user = {
    flag: "refreshtoken",
    parameters: {
      refreshToken: params,
    },
  };
  return client.post("/auth", user);
};

export const reset = (params) => {
  const user = {
    flag: "reset",
    parameters: params,
  };
  return client.post("/auth", user);
};

export const forgot = (params) => {
  const user = {
    flag: "forgot",
    parameters: params,
  };
  return client.post("/auth", user);
};
